export default class BaseModel {
    init(obj){
        for(let key in obj){
            if(!key.startsWith('_')){
                this[key] = obj[key]
            }
        }
        return this
    }

    copy(obj) {
        for(let key in obj){
            this[key] = obj[key]
        }
        return this
    }

    

    getSaveObj() {
        const obj = {}
        for(let key in this){
            if(!key.startsWith('_')){
                obj[key] = this[key]
            }
        }
        return obj
    }
}